export default (function (formValue) {
  if (!formValue) return '';
  if (Array.isArray(formValue) && formValue.length > 0) {
    return String(formValue[0]);
  }
  return String(formValue);
});